// NUCLEAR OPTION: Complete cart security cleanup
// This completely eliminates ANY possibility of price manipulation

export function nuclearCartCleanup() {
  console.warn('🚨 NUCLEAR CLEANUP: Completely sanitizing cart storage');
  
  try {
    // Get current cart data
    const cartData = localStorage.getItem('lillaflora_cart');
    
    if (cartData) {
      const parsed = JSON.parse(cartData);
      
      // Extract ONLY IDs and quantities, destroy everything else
      const nukedCart = Array.isArray(parsed) 
        ? parsed
            .filter(item => item && typeof item.id === 'number' && typeof item.quantity === 'number')
            .map(item => ({
              id: item.id,
              quantity: item.quantity
            }))
        : [];
      
      // Force write the nuked cart
      localStorage.removeItem('lillaflora_cart');
      localStorage.setItem('lillaflora_cart', JSON.stringify(nukedCart));
      
      console.warn('☢️ NUKED: Cart cleaned to secure format');
      console.log('🔒 SECURE CART:', nukedCart);
      
      return nukedCart;
    }
    
    // If no cart, ensure it's empty
    localStorage.setItem('lillaflora_cart', '[]');
    return [];
    
  } catch (error) {
    console.error('Error in nuclear cleanup:', error);
    // Emergency protocol: completely clear cart
    localStorage.removeItem('lillaflora_cart');
    localStorage.setItem('lillaflora_cart', '[]');
    return [];
  }
}

// Auto-nuke on import
nuclearCartCleanup();

// Export for manual use
export default nuclearCartCleanup;